import React, { Component } from "react";
import ReactDOM from "react-dom";

import AgentRole  from "./AgentRole";
import AgentAvatar  from "./AgentAvatar";
import {connect} from "react-redux";

const columns = [
    { title: "user", data:'username' },
    { title: "name surname", data:'username'  },
    { title: "e-mail", data:'email' },
    { title: "role", data: 'role' },
    { title: "status", data:"state" },
    { title: "chat limit", data:"chat_limit" },
    { title: "active chat", data:"active_chat" },
    { title: "detail", data:"id"},
];
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AgentDatatable extends Component {
    constructor(props) {
        super(props);

        this.searchDatatable=this.searchDatatable.bind(this);
        this.searchValue=React.createRef();
    }

    componentDidMount() {
        this.$el = $(this.el);

        this.$el.DataTable({
            dom: '<"data-table-wrapper'+this.props.id+'"t>',
            data: this.props.type=="all" ? this.props.chatprop.allAgents : this.props.chatprop.allAgents.filter(this.props.type),
            columns: columns,
			pageLength:100,
            ordering: true,
            order:[[ 4, "asc" ]],
            columnDefs: [
                {
                    targets: [7],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(

                           <div>
                               {rowData.state !== 3 &&
                               <a href="" className=" btn btn-trigger mr-2 text-primary btn-icon " onClick={e=>this.props.editAgent(e, rowData.id)}><i
                                   className="bx bxs-edit icon" title="Edit"></i></a>
                               }
                               {rowData.state !== 3 &&
                               <a href="" className=" btn btn-trigger mr-2 text-primary btn-icon " onClick={e=>this.props.openAgentDetail(e, rowData.id)} ><i className="bx bxs-user-detail icon" title="Details"></i></a>
                               }
                               {rowData.role !== 1 && rowData.state!==3 &&
                               <a href="" className=" btn btn-trigger mr-2 text-primary btn-icon " onClick={e=>this.props.removeAgent(e, rowData.id)} ><i className="bx bx-trash icon" title="Remove"></i></a>
                               }
                           </div>
                               , td ), },

                {
                    targets: [6],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                            <span className="badge badge-light">{rowData.active_chat}</span>
                            , td ), },


                {
                    targets: [5],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                            <span className="badge badge-light">{rowData.chat_limit}</span>
                            , td ), },

                {
                    targets: [0],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                                    <AgentAvatar user={rowData}/>
                            , td ), },
                {
                    targets: [1],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                            <div className="agent-name"> <h5> {rowData.username} </h5><p>Registration Date : {rowData.creation_date}</p> </div>, td ), },

                {
                    targets: [3],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                                      <AgentRole role={rowData.role}  />
                            , td ),

                },
                {
                    targets: [4],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                               <div className="active-control">

                                       {rowData.state !== 3 &&
                                           <label className="switch">
                                               <input type="checkbox" className="changeUserState changeUserState"
                                                      checked={rowData.state == 1 ? true : false}
                                                      onChange={e => this.props.changeUserState(e, rowData.id)}/>
                                               <span className="slider round"></span>
                                           </label>
                                       }
                                       <div className="states">
                                           {rowData.state == 1 &&
                                               <span>Active</span>
                                           }
                                           {rowData.state == 2 &&
                                           <span>Suspended</span>
                                           }
                                           {rowData.state == 3 &&
                                           <span style={{color:"red"}}>Deleted</span>
                                           }
                                       </div>

                               </div>
                            , td ),

                },
            ],
        });
    }
    searchDatatable(){
        var table = $('.data-table-wrapper'+ this.props.id).find('table').DataTable();
        table.search(this.searchValue.current.value).draw();
    }
    componentWillUnmount() {
        $(".data-table-wrapper"+this.props.id).find("table").DataTable().destroy(true);
    }
    reloadTableData = (data) => {

        var table = $('.data-table-wrapper'+ this.props.id).find('table').DataTable();

        table.clear();
        table.rows.add(data);
        table.draw();
    }
    shouldComponentUpdate(nextProps, nextState){
        this.props.type=="all" ? this.reloadTableData(nextProps.chatprop.allAgents) :this.reloadTableData(nextProps.chatprop.allAgents.filter(this.props.type))


        return false;
    }
    render() {
        return (
            <React.Fragment>
                <div className="search_chat has-search ml-0 mb-3">
                    <span className="bx bx-search-alt form-control-feedback"></span>
                    <input className=" chat_input" type="text"
                           onKeyUp={e=>this.searchDatatable(e)}
                           ref={this.searchValue}
                           placeholder="Search Agent by E-Mail, Name Surname or Phone Number.." />
                </div>
                <table className=" display nowrap"
                       id={"dataTable"+this.props.id}
                       width="100%"
                       cellSpacing="0"
                       ref={(el) => (this.el = el)}
                />
            </React.Fragment>
        );
    }
}
export default AgentDatatable;
